import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import VectorImage from '~components/media/vectorImage';
import PageLayout from '~layouts/page/pageLayout';
import { Dimens } from '~themes';

const HomePage = () => {
	const { t } = useTranslation();
	return (
		<PageLayout pageTitle={t('dashboard', { ns: 'nav' })} crumbs={[]}>
			<Box
				sx={{
					height: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Box
					sx={{
						width: '100%',
						maxWidth: '800px',
						paddingLeft: Dimens.spacingMd,
						paddingRight: Dimens.spacingMd,
					}}
				>
					<VectorImage name='illustration/dashboard' size='100%' />
				</Box>
			</Box>
		</PageLayout>
	);
};

export default HomePage;
